import { createContext } from "react";

export const MemberDetails = createContext({});
